import { useIsMobile } from "@/hooks/use-mobile"
import { cn } from "@/lib/utils"

export function ModuleTitle({
	title,
	extra,
}: {
	title: string
	extra?: React.ReactNode
}) {
	const isMobile = useIsMobile()

	// Hide title on mobile since drawer already has title
	if (isMobile) {
		return null
	}

	return <ModuleSectionTitle title={title} extra={extra} />
}

export function ModuleSectionTitle({
	title,
	extra,
	className,
}: {
	title: string
	extra?: React.ReactNode
	className?: string
}) {
	return (
		<h2
			className={cn(
				// 响应式无关 - 字体、颜色、对齐等
				"font-['DINPro'] md:font-['DINPro-Bold']  font-bold text-[#111] md:text-black text-left not-italic",
				// 响应式相关 - 字号、行高、外边距
				"text-base md:text-2xl leading-none mb-2 md:mb-4",
				className,
			)}
		>
			{title}
			{extra && <span className="text-gray-500">{extra}</span>}
		</h2>
	)
}
